export var EnvironmentStatus;
(function (EnvironmentStatus) {
    EnvironmentStatus["ACTIVE"] = "ACTIVE";
    EnvironmentStatus["DRAFT"] = "DRAFT";
    EnvironmentStatus["NOT_ACTIVE"] = "NOT ACTIVE";
    EnvironmentStatus["REQUESTED"] = "REQUESTED";
    EnvironmentStatus["DELETED"] = "DELETED";
})(EnvironmentStatus || (EnvironmentStatus = {}));
//# sourceMappingURL=environment-status.js.map